module.exports = __webpack_public_path__ + "static/img/top.a6bc7f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top.png
// module id = Uw9C
// module chunks = 1